// extracted by mini-css-extract-plugin
module.exports = {"variant_fill":"📚4-7-016uz6","variant_outline":"📚4-7-0118FQ","Textarea":"📚4-7-0IcRyt","resizable":"📚4-7-01GXuk"};